import { FC, MouseEvent, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Button, Menu, MenuItem } from '@mui/material';
import { isPast, parseISO } from 'date-fns';
import { ETLJobRecurrenceEnum, ETLScheduledJob } from '~/api/types';
import { useDeleteETLJobMutation } from '~/api/v2/hooks';
import { DeleteTypeEnum } from '~/components';
import { tableActionButtonStyles } from '~/components/styles';
import { VerticalDotsIcon } from '~/icons';
import { useAppDispatch } from '~/redux';
import { ModalTypesEnum, openModal } from '~/redux/slices/modalSlice';
import { isWithinMinutesFromNowUTC } from '~/utils';

const FORBID_EDIT_MINUTES = 2;

interface JobActionsCellProps {
  row: ETLScheduledJob;
}

const JobActionsCell: FC<JobActionsCellProps> = ({ row }) => {
  const projectId = +useParams().projectid!;
  const dispatch = useAppDispatch();
  const [deleteJob] = useDeleteETLJobMutation({ fixedCacheKey: 'delete-etl-job' });
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleMoreClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMoreMenu = () => {
    setAnchorEl(null);
  };

  const isStartDateInPast = row.start_date ? isPast(parseISO(row.start_date)) : false;

  const isEditDisabled =
    row.frequency === ETLJobRecurrenceEnum.NOT_REPEAT && isWithinMinutesFromNowUTC(row.start_date, FORBID_EDIT_MINUTES);

  return (
    <>
      <Button
        sx={tableActionButtonStyles}
        endIcon={<VerticalDotsIcon style={{ marginLeft: '1rem' }} />}
        onClick={handleMoreClick}
      >
        More
      </Button>
      <Menu elevation={1} anchorEl={anchorEl} open={open} onClose={handleCloseMoreMenu}>
        <MenuItem
          disabled={isEditDisabled || isStartDateInPast}
          onClick={() => {
            dispatch(
              openModal({
                type: ModalTypesEnum.ETL_SCHEDULE_JOB,
                payload: { jobId: row.id },
              }),
            );
            handleCloseMoreMenu();
          }}
        >
          Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            dispatch(
              openModal({
                type: ModalTypesEnum.DELETE_CONFIRMATION,
                payload: {
                  type: DeleteTypeEnum.ETL_JOB,
                  onDelete: () => {
                    deleteJob({ projectId, jobId: row.id });
                  },
                  itemName: row.name,
                },
              }),
            );
            handleCloseMoreMenu();
          }}
        >
          Delete
        </MenuItem>
      </Menu>
    </>
  );
};

export default JobActionsCell;
